import mqtt from 'mqtt';

export default class MqttClient {
    constructor(broker) {
        this.client = null;
        this.messageCallback = null;
        this.broker = broker;
    }

    onMessage(callback) {
        this.messageCallback = callback;
    }

    connect(...topics) {
        this.client = mqtt.connect(this.broker);
        this.client.on('connect', () => {
            console.log("mqtt connected: ", this.broker);
            topics.forEach((topic) => {
                this.subscribe(topic)
            });
        });

        this.client.on('message', (topic, message) => {
            if (this.messageCallback) {
                this.messageCallback(topic, message.toString());
            }
        });
    }

    subscribe(topic) {
        this.client.subscribe(topic, (err) => {
            if (!err) {
                console.log(topic, "subscribed!");
            }
        })
    }

    sendMessage(topic, text) {
        this.client.publish(topic, text);
    }

    disconnect() {
        this.client.end();
    }
}